export const initAnnualDinnerCookie = () => {
	const queryString = window.location.search;
	if (queryString.length > 0) {
		const urlParams = new URLSearchParams(queryString);
		const src = urlParams.get("src");
		if (src != null && src != undefined && src === "annualdinner") {
			//Apply setCookie
			setCookie("src", "annualdinner", 3);
		}
	}

	//Set a Cookie
	function setCookie(cName, cValue, expDays) {
		// console.log('cName, cValue, expDays', cName, cValue, expDays);
		let date = new Date();
		date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
		const expires = "expires=" + date.toUTCString();
		document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
	}
};
